<div class="product-list-container">
  <!-- Loader -->
  <div *ngIf="isLoading" class="loader-container">
    <div class="pulse-loader"></div>
    <p class="loading-text">Chargement des produits...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="content-wrapper">
    <!-- Dashboard Cards -->
    <div class="stats-container">
      <div class="stat-card total">
        <div class="stat-info">
          <span class="stat-value">{{ productSize }}</span>
          <span class="stat-label">Produits totaux</span>
        </div>
        <div class="stat-icon">
          <i class="fa fa-boxes"></i>
        </div>
      </div>

      <div class="stat-card in-stock">
        <div class="stat-info">
          <span class="stat-value">{{ inStockCount }}</span>
          <span class="stat-label">En stock</span>
        </div>
        <div class="stat-icon">
          <i class="fa fa-check-circle"></i>
        </div>
      </div>

      <div class="stat-card low-stock">
        <div class="stat-info">
          <span class="stat-value">{{ lowStockCount }}</span>
          <span class="stat-label">Faible stock</span>
        </div>
        <div class="stat-icon">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
      </div>

      <div class="stat-card out-of-stock">
        <div class="stat-info">
          <span class="stat-value">{{ outOfStockCount }}</span>
          <span class="stat-label">Rupture de stock</span>
        </div>
        <div class="stat-icon">
          <i class="fa fa-times-circle"></i>
        </div>
      </div>
    </div>

    <!-- Header with Search and Filters -->
    <div class="table-header">
      <div class="header-title">
        <h2>Gestion des produits</h2>
        <p>{{ productSize }} produits trouvés</p>
      </div>

      <div class="header-actions">
        <div class="search-container">
          <i class="fa fa-search search-icon"></i>
          <input type="search" class="search-input" placeholder="Rechercher un produit..."
            (input)="onInputChange($event)">
        </div>

        <div class="filter-container">
          <select (change)="onStockStatusChange($event)" class="filter-select">
            <option value="">Tous les statuts</option>
            <option value="faibleStock">Faible Stock</option>
            <option value="enRuptureDeStock">Rupture de Stock</option>
            <option value="enStock">En Stock</option>
          </select>
        </div>

        <button routerLink="/addProduct" class="add-product-btn">
          <i class="fa fa-plus"></i>
          <span>Ajouter un produit</span>
        </button>
      </div>
    </div>

    <!-- Desktop Table View -->
    <div class="table-container desktop-view">
      <div class="table-responsive">
        <table class="product-table">
          <thead>
            <tr>
              <th>CODE</th>
              <th>PRODUIT</th>
              <th>PRIX VENTE</th>
              <th>PRIX ACHAT</th>
              <th>QUANTITÉ</th>
              <th>STATUT</th>
              <th class="text-center">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of pagedItems" class="product-row">
              <td class="product-code">{{ product?.codeBare }}</td>
              <td class="product-info">
                <div class="product-name-container">
                  <span class="product-name">{{ product?.name }}</span>
                </div>
              </td>
              <td class="product-price">{{ product?.price }} DH</td>
              <td class="product-cost">{{ product?.purchasePrice }} DH</td>
              <td class="product-quantity">{{ product?.quantity }} {{ product?.unit }}</td>

              <td class="product-status">
                <span *ngIf="isProductInStock(product)" class="status-badge in-stock">
                  <i class="fa fa-circle"></i> En stock
                </span>
                <span *ngIf="isProuctOutOfStock(product)" class="status-badge out-of-stock">
                  <i class="fa fa-circle"></i> Rupture
                </span>
                <span *ngIf="isProductIsLowStock(product)" class="status-badge low-stock">
                  <i class="fa fa-circle"></i> Faible
                </span>
              </td>

              <td class="actions-column">
                <a class="action-btn print" (click)="openPrintDialog([product])" title="Imprimer code-barre">
                  <i class="fa fa-print text-print"></i>
                </a>
                <a class="action-btn edit" (click)="updateProduct(product)">
                  <i class="fa fa-pen text-primary"></i>
                </a>
                <a class="action-btn delete" (click)="openDeleteConfirmation(product)">
                  <i class="fa fa-trash text-danger"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Mobile Card View -->
    <div class="product-cards-container mobile-view">
      <div *ngFor="let product of pagedItems" class="product-card">
        <div class="product-card-header">
          <div class="product-image-placeholder">
            <i class="fa fa-box"></i>
          </div>
          <div class="product-card-details">
            <div class="product-card-name">{{ product?.name }}</div>
            <div class="product-card-code">Code: {{ product?.codeBare }}</div>
          </div>
        </div>

        <div class="product-card-body">
          <div class="product-card-info">
            <div class="info-item">
              <span class="info-label">Prix vente:</span>
              <span class="info-value">{{ product?.price }} DH</span>
            </div>
            <div class="info-item">
              <span class="info-label">Prix achat:</span>
              <span class="info-value">{{ product?.purchasePrice }} DH</span>
            </div>
            <div class="info-item">
              <span class="info-label">Quantité:</span>
              <span class="info-value">{{ product?.quantity }} {{ product?.unit }}</span>
            </div>
          </div>

          <div class="product-card-status">
            <span *ngIf="isProductInStock(product)" class="status-badge in-stock">
              <i class="fa fa-circle"></i> En stock
            </span>
            <span *ngIf="isProuctOutOfStock(product)" class="status-badge out-of-stock">
              <i class="fa fa-circle"></i> Rupture
            </span>
            <span *ngIf="isProductIsLowStock(product)" class="status-badge low-stock">
              <i class="fa fa-circle"></i> Faible stock
            </span>
          </div>
        </div>

        <div class="product-card-actions">
          <button class="action-btn print" (click)="openPrintDialog([product])">
            <i class="fa fa-print"></i> Imprimer
          </button>
          <button class="action-btn edit" (click)="updateProduct(product)">
            <i class="fa fa-pen"></i> Modifier
          </button>
          <button class="action-btn delete" (click)="openDeleteConfirmation(product)">
            <i class="fa fa-trash"></i> Supprimer
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="pagedItems.length === 0" class="empty-state">
      <i class="fa fa-box-open empty-icon"></i>
      <h3>Aucun produit trouvé</h3>
      <p>Essayez de modifier vos critères de recherche ou ajoutez un nouveau produit</p>
      <button routerLink="/addProduct" class="add-product-btn">
        <i class="fa fa-plus"></i>
        <span>Ajouter un produit</span>
      </button>
    </div>

    <!-- Paginator -->
    <app-paginator [totalItems]="productSize" [itemsPerPage]="productsPerPage" [currentPage]="currentPage"
      [pages]="pages" [pagedItemsSize]="pagedItemsSize" (pageChange)="onPageChange($event)">
    </app-paginator>

    <!-- Confirmation Dialog -->
    <app-confirmation-dialog [isVisible]="showDeleteConfirmation" title="Confirmer la suppression"
      message="Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible." confirmText="Supprimer"
      cancelText="Annuler" type="danger" (confirm)="confirmDelete()" (cancel)="cancelDelete()" (close)="cancelDelete()">
    </app-confirmation-dialog>
  </div>
</div>